import { render, staticRenderFns } from "./Sofascore.vue?vue&type=template&id=36f74a57&scoped=true&"
import script from "./Sofascore.vue?vue&type=script&lang=js&"
export * from "./Sofascore.vue?vue&type=script&lang=js&"
import style0 from "./Sofascore.vue?vue&type=style&index=0&id=36f74a57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f74a57",
  null
  
)

export default component.exports